// extracted by mini-css-extract-plugin
export var cardItemSection__desktopLink = "CardItemSection-module--cardItemSection__desktopLink--d75b8";
export var cardItemSection__header = "CardItemSection-module--cardItemSection__header--7222d";
export var cardItemSection__link = "CardItemSection-module--cardItemSection__link--9151e";
export var cardItemSection__mobileLink = "CardItemSection-module--cardItemSection__mobileLink--b588f";
export var cardItemSection__title = "CardItemSection-module--cardItemSection__title--866af";